import ReactMarkdown from 'react-markdown';

interface PositSummaryProps {
  summary: string | null;
  summaryLight?: string | null;
}

const PositSummary = ({ summary, summaryLight }: PositSummaryProps) => {
  // Prefer summaryLight if available, fall back to summary
  const displaySummary = summaryLight || summary;
  
  if (!displaySummary) return null;

  return (
    <div className="prose prose-slate dark:prose-invert max-w-none">
      <ReactMarkdown>{displaySummary}</ReactMarkdown>
    </div>
  );
};

export default PositSummary;